import { SmileOutlined } from '@ant-design/icons';
import { notification } from 'antd';
//import LogoEsfera from '../../../globals/images/Layout/logo-esfera.png';
import style from './Notificaction.module.scss'

export const openNotification = (title: String, subTitle: String) => {
  notification.open({
    message: <div className={style["text-title-notification"]}>{title}</div>,
    description:
      <div className={style["text-notification"]}>{subTitle}</div>,
    // icon: <img className={style["logo-notification"]} loading="lazy" src={LogoEsfera} alt="return"></img>,
    placement:'topLeft'
  });
};